import {FC} from 'react'
import {useLang} from './RootI18n'
import {IntlProvider} from 'react-intl'
import '@formatjs/intl-relativetimeformat/polyfill'
import '@formatjs/intl-relativetimeformat/locale-data/en'
import '@formatjs/intl-relativetimeformat/locale-data/ru'

import enMessages from './messages/en.json'
import ruMessages from './messages/ru.json'
import {WithChildren} from '../helpers/react18MigrationHelpers'

const allMessages = {
  en: enMessages,
  ru: ruMessages,
}

const I18nProvider: FC<WithChildren> = ({children}) => {
  const locale = useLang()
  const messages = allMessages[locale]

  return (
    <IntlProvider locale={locale} messages={messages}>
      {children}
    </IntlProvider>
  )
}

export {I18nProvider}
